import { environment } from "src/environments/environment";

const headers = {
	"x-rapidapi-host": "api-football-v1.p.rapidapi.com",
	"x-rapidapi-key": environment.externalAPIs.apiFootball.apiKey
};

/** API-Football (api-sports via RapidAPI) - used to import away squads. */
export const ApiFootballService = {
	getSquad: async (teamId: number) => await fetch(`${environment.externalAPIs.apiFootball.url}/players/squads?team=${teamId}`, { headers, method: "GET" }),
	searchTeams: async (name: string) => await fetch(`${environment.externalAPIs.apiFootball.url}/teams?search=${encodeURIComponent(name)}`, { headers, method: "GET" })
}
